import { SyntheseInventaireUniteEdition } from './synthese-inventaire-unite-edition';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SyntheseInventaireEspeceEdition {
    static jsonMap = {
        libelleEspece: { key: 'libelleEspece', optional: true, default: '' },
        uniteCulturaleEditionList: {
            key: 'uniteCulturaleEditionList',
            converter: new (ArrayClassConverterFactory.build(SyntheseInventaireUniteEdition))(),
            optional: true
        },
        surface: { key: 'surface', optional: true },
        surfaceIrriguee: { key: 'surfaceIrriguee', optional: true },
        surfaceGrele: { key: 'surfaceGrele', optional: true },
        surfaceGel: { key: 'surfaceGel', optional: true },
        surfaceBio: { key: 'surfaceBio', optional: true }
    };

    libelleEspece: string;
    uniteCulturaleEditionList: SyntheseInventaireUniteEdition[];
    surface: number;
    surfaceIrriguee: number;
    surfaceGrele: number;
    surfaceGel: number;
    surfaceBio: number;
}
